import { Box, HStack, Text, useToken } from 'native-base';
import React, { ReactNode } from 'react';

import { Warning } from 'app/components/icons';
import { AttractionConfig } from 'app/services/GuestCenterService.types';
import { ReservationTextHelper } from 'app/services/I18n';
import { tID } from 'app/services/TestHelper';

export type AttractionClosedLabelProps = {
  children?: ReactNode;
  attrConfig: AttractionConfig | undefined;
  fontSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  rt: ReservationTextHelper;
  pt: number;
};

export default function ReservationRequirementLabel({
  attrConfig,
  fontSize,
  rt,
  pt = 1,
}: AttractionClosedLabelProps) {
  const size = useToken('fontSizes', fontSize ?? 'md');

  return (
    <Box pt={pt} testID={tID('AttractionClosed')}>
      <HStack alignItems="center" flexWrap="wrap" space="1">
        <Warning size={size} />
        <Text>{rt('attraction_closed')}</Text>
      </HStack>
    </Box>
  );
}
